import { render } from "./CartDialog.vue?vue&type=template&id=527ea878"
import script from "./CartDialog.vue?vue&type=script&lang=js"
export * from "./CartDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__